export const MediaType = {
  AUDIO: 'audio',
  VIDEO: 'video',
  NONE: 'none',
} as const;
export type MediaType = (typeof MediaType)[keyof typeof MediaType];

export namespace ConnectyCubeMedia {
  export interface ElementOptions {
    muted?: boolean;
    mirror?: boolean;
  }
  export interface ElementParams {
    elementId?: string;
    options?: ElementOptions;
  }
  export interface DisplayParams extends DisplayMediaStreamOptions, ElementParams {}
  export interface UserParams extends MediaStreamConstraints, ElementParams {}
  export type DeviceIdOrTrackConstraints = MediaTrackConstraints | string;
  export type TrackConstraintsOrDeviceIds = {
    audio?: DeviceIdOrTrackConstraints;
    video?: DeviceIdOrTrackConstraints;
  };
}
